/**
 * Coups de pouce — attendu 627 (établir des égalités de fractions).
 *
 * Routage par generator_key (12 keys de format).
 * Exemple HORS pool : 8/11 absent de POOL_A (les onzièmes s'arrêtent à 7/11),
 * donc aucun tirage des keys routées ne peut produire 8/11 = 16/22.
 */

// La propriété rendue VISIBLE : l'égalité à trou, le coefficient repéré sur
// les dénominateurs (× 2 en bas), puis appliqué aux numérateurs (× 2 en
// haut). Un seul geste : le même nombre en haut et en bas.
const SVG_REGLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 168" width="290" height="162" role="img" data-etapes="4"
     aria-label="On complète l’égalité : huit onzièmes égale combien de vingt-deuxièmes ? En bas, 11 a été multiplié par 2 pour donner 22 : le coefficient est 2. En haut, on multiplie aussi par 2 : 8 fois 2 égale 16. On a multiplié le numérateur et le dénominateur par le même nombre : huit onzièmes égale seize vingt-deuxièmes">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp627rg 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp627rgc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp627rg 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp627rgc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp627rg 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp627rgc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp627rg 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp627rgcf 8s linear infinite 6s; }
    }
    @keyframes cp627rg { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp627rgc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp627rgcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <text x="85" y="60" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">8</text>
    <line x1="68" y1="68" x2="102" y2="68" stroke="#334155" stroke-width="2"/>
    <text x="85" y="92" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">11</text>
    <text x="126" y="75" text-anchor="middle" font-size="20" fill="#334155">=</text>
    <rect x="154" y="42" width="36" height="22" fill="none" stroke="#f97316" stroke-width="1.5" stroke-dasharray="4 3"/>
    <line x1="150" y1="68" x2="194" y2="68" stroke="#334155" stroke-width="2"/>
    <text x="172" y="92" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">22</text>
  </g>
  <g class="anim d2" data-etape="2">
    <path d="M 92 102 Q 128 134 158 106" fill="none" stroke="#dc2626" stroke-width="2"/>
    <polygon points="162,103 151,110 152,100" fill="#dc2626"/>
    <text x="126" y="136" text-anchor="middle" font-size="14" font-weight="bold" fill="#dc2626">× 2</text>
  </g>
  <g class="anim d3" data-etape="3">
    <path d="M 92 38 Q 128 8 158 32" fill="none" stroke="#f97316" stroke-width="2"/>
    <polygon points="162,35 151,38 153,28" fill="#f97316"/>
    <text x="126" y="14" text-anchor="middle" font-size="14" font-weight="bold" fill="#f97316">× 2</text>
    <text x="172" y="60" text-anchor="middle" font-size="20" font-weight="bold" fill="#f97316">16</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="215" y="78" text-anchor="middle" font-size="22" font-weight="bold" fill="#16a34a">✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">complète : combien de <tspan font-weight="bold" fill="#f97316">vingt-deuxièmes</tspan> ?</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">en bas : 11 × 2 = 22, le coefficient est <tspan font-weight="bold" fill="#dc2626">× 2</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">en haut <tspan font-weight="bold">aussi</tspan> : 8 × 2 = <tspan font-weight="bold" fill="#f97316">16</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155"><tspan font-weight="bold">même nombre</tspan> en haut et en bas : 8/11 = 16/22 <tspan font-weight="bold" fill="#16a34a">✓</tspan></text>
  </g>
</svg>`.trim();

const FICHE_REGLE = {
    pages: [
        {
            titre: 'Le même nombre en haut et en bas',
            lignes: [
                'Une fraction ne change pas de valeur quand on **multiplie** son numérateur **et** son dénominateur par un **même nombre**.',
                'Cherche le coefficient sur la partie que tu connais, puis **applique-le à l\'autre**. Prends ton brouillon.',
            ],
            svg: SVG_REGLE,
        },
    ],
};

// L'entier ramené au geste de FICHE_REGLE, en ANIMÉ (retour user) : l'entier
// s'écrit n/1, on cherche le numérateur, la propriété donne le coefficient
// par les dénominateurs (1 → 2 : × 2), le numérateur tombe. Exemple HORS
// pool : n = 12 absent de POOL_C (n s'arrête à 10), même ×2 que FICHE_REGLE.
const SVG_ENTIER = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 168" width="290" height="162" role="img" data-etapes="4"
     aria-label="Tout entier s’écrit en fraction : 12 égale 12 sur 1. On cherche le numérateur : 12 égale combien de demis ? On utilise la propriété des égalités de fractions : pour passer du dénominateur 1 au dénominateur 2, on multiplie par 2. On multiplie aussi le numérateur : 12 fois 2 égale 24. Donc 12 égale 24 sur 2">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp627en 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp627enc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp627en 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp627enc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp627en 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp627enc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp627en 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp627encf 8s linear infinite 6s; }
    }
    @keyframes cp627en { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp627enc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp627encf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <text x="42" y="75" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">12</text>
    <text x="68" y="75" text-anchor="middle" font-size="20" fill="#334155">=</text>
    <text x="100" y="60" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">12</text>
    <line x1="84" y1="68" x2="116" y2="68" stroke="#334155" stroke-width="2"/>
    <text x="100" y="92" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">1</text>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="132" y="75" text-anchor="middle" font-size="20" fill="#334155">=</text>
    <rect x="156" y="42" width="36" height="22" fill="none" stroke="#f97316" stroke-width="1.5" stroke-dasharray="4 3"/>
    <line x1="152" y1="68" x2="196" y2="68" stroke="#334155" stroke-width="2"/>
    <text x="174" y="92" text-anchor="middle" font-size="20" font-weight="bold" fill="#334155">2</text>
  </g>
  <g class="anim d3" data-etape="3">
    <path d="M 107 102 Q 138 134 160 106" fill="none" stroke="#dc2626" stroke-width="2"/>
    <polygon points="164,103 153,110 154,100" fill="#dc2626"/>
    <text x="136" y="136" text-anchor="middle" font-size="14" font-weight="bold" fill="#dc2626">× 2</text>
  </g>
  <g class="anim d4" data-etape="4">
    <path d="M 107 38 Q 138 8 160 32" fill="none" stroke="#f97316" stroke-width="2"/>
    <polygon points="164,35 153,38 155,28" fill="#f97316"/>
    <text x="136" y="14" text-anchor="middle" font-size="14" font-weight="bold" fill="#f97316">× 2</text>
    <text x="174" y="60" text-anchor="middle" font-size="20" font-weight="bold" fill="#f97316">24</text>
    <text x="218" y="78" text-anchor="middle" font-size="22" font-weight="bold" fill="#16a34a">✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">un entier, c’est <tspan font-weight="bold">déjà une fraction</tspan> : 12 = 12/1</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">on cherche le <tspan font-weight="bold" fill="#f97316">numérateur</tspan> : 12, c’est combien de demis ?</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">pour passer de 1 à 2, on multiplie par <tspan font-weight="bold" fill="#dc2626">2</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="160" text-anchor="middle" font-size="11.5" fill="#334155">en haut <tspan font-weight="bold">aussi</tspan> : 12 × 2 = <tspan font-weight="bold" fill="#f97316">24</tspan>, donc 12 = 24/2 <tspan font-weight="bold" fill="#16a34a">✓</tspan></text>
  </g>
</svg>`.trim();

const FICHE_ENTIER = {
    pages: [
        {
            titre: 'Un entier, c\'est aussi une fraction',
            lignes: [
                'Tout entier s\'écrit déjà en fraction : $12 = \\dfrac{12}{1}$.',
                'Puis utilise la **propriété des égalités de fractions** : cherche par combien on multiplie pour passer d\'un dénominateur à l\'autre, et fais pareil au numérateur. Prends ton brouillon.',
            ],
            svg: SVG_ENTIER,
        },
    ],
};

// Le relier disques : la MÊME surface coloriée sous deux partages (écho des
// partages emboîtés de 623 et de « la même longueur » de 626, version
// disque). Exemple HORS pool : 1/2 = 5/10 — k = 5 impossible (k ∈ [2, 4])
// et 5/10 n'est l'étendue d'aucun couple du pool disques.
const SVG_DISQUES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 176" width="290" height="170" role="img" data-etapes="4"
     aria-label="Un disque est coupé en 2 parts, 1 est coloriée : un demi. Le même disque est coupé en 10 parts : 5 sont coloriées, cinq dixièmes. La surface coloriée est la même : les deux fractions sont égales. On vérifie avec la propriété : 1 fois 5 égale 5, et 2 fois 5 égale 10">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp627dq 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp627dqc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp627dq 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp627dqc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp627dq 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp627dqc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp627dq 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp627dqcf 8s linear infinite 6s; }
    }
    @keyframes cp627dq { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp627dqc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp627dqcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <path d="M 75 66 L 75 34 A 32 32 0 0 1 75 98 Z" fill="#fb923c" fill-opacity="0.7"/>
    <circle cx="75" cy="66" r="32" fill="none" stroke="#334155" stroke-width="1.5"/>
    <line x1="75" y1="34" x2="75" y2="98" stroke="#334155" stroke-width="1.5"/>
    <text x="75" y="118" text-anchor="middle" font-size="13" font-weight="bold" fill="#334155">1</text>
    <line x1="68" y1="122" x2="82" y2="122" stroke="#334155" stroke-width="1.5"/>
    <text x="75" y="135" text-anchor="middle" font-size="13" font-weight="bold" fill="#334155">2</text>
  </g>
  <g class="anim d2" data-etape="2">
    <path d="M 205 66 L 205 34 A 32 32 0 0 1 205 98 Z" fill="#fb923c" fill-opacity="0.7"/>
    <circle cx="205" cy="66" r="32" fill="none" stroke="#334155" stroke-width="1.5"/>
    <line x1="205" y1="66" x2="205" y2="34" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="223.81" y2="40.11" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="235.43" y2="56.11" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="235.43" y2="75.89" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="223.81" y2="91.89" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="205" y2="98" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="186.19" y2="91.89" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="174.57" y2="75.89" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="174.57" y2="56.11" stroke="#334155" stroke-width="1.2"/>
    <line x1="205" y1="66" x2="186.19" y2="40.11" stroke="#334155" stroke-width="1.2"/>
    <text x="205" y="118" text-anchor="middle" font-size="13" font-weight="bold" fill="#334155">5</text>
    <line x1="197" y1="122" x2="213" y2="122" stroke="#334155" stroke-width="1.5"/>
    <text x="205" y="135" text-anchor="middle" font-size="13" font-weight="bold" fill="#334155">10</text>
  </g>
  <g class="anim d3" data-etape="3">
    <text x="140" y="72" text-anchor="middle" font-size="22" font-weight="bold" fill="#16a34a">=</text>
    <path d="M 75 66 L 75 34 A 32 32 0 0 1 75 98 Z" fill="none" stroke="#16a34a" stroke-width="2.5"/>
    <path d="M 205 66 L 205 34 A 32 32 0 0 1 205 98 Z" fill="none" stroke="#16a34a" stroke-width="2.5"/>
  </g>
  <g class="anim d4" data-etape="4">
    <path d="M 84 114 Q 140 98 196 114" fill="none" stroke="#f97316" stroke-width="2"/>
    <polygon points="199,116 188,116 191,107" fill="#f97316"/>
    <text x="140" y="102" text-anchor="middle" font-size="13" font-weight="bold" fill="#f97316">× 5</text>
    <path d="M 84 140 Q 140 158 196 140" fill="none" stroke="#dc2626" stroke-width="2"/>
    <polygon points="199,138 188,137 190,147" fill="#dc2626"/>
    <text x="140" y="160" text-anchor="middle" font-size="13" font-weight="bold" fill="#dc2626">× 5</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="173" text-anchor="middle" font-size="11.5" fill="#334155">un disque en <tspan font-weight="bold">2 parts</tspan>, 1 coloriée : 1/2</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="173" text-anchor="middle" font-size="11.5" fill="#334155">le <tspan font-weight="bold">même disque</tspan> en 10 parts : 5 coloriées, 5/10</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="173" text-anchor="middle" font-size="11.5" fill="#334155">la <tspan font-weight="bold" fill="#16a34a">surface coloriée</tspan> est la même !</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="173" text-anchor="middle" font-size="11.5" fill="#334155">vérifie : <tspan font-weight="bold" fill="#f97316">× 5</tspan> en haut et en bas, 1/2 = 5/10 <tspan font-weight="bold" fill="#16a34a">✓</tspan></text>
  </g>
</svg>`.trim();

const FICHE_DISQUES = {
    pages: [
        {
            titre: 'La même surface, deux partages',
            lignes: [
                'Compte les parts du disque : c\'est le **dénominateur**. Compte les parts coloriées : c\'est le **numérateur**.',
                'Deux disques vont ensemble quand la **surface coloriée est la même**. Vérifie avec la propriété : **le même coefficient** en haut et en bas.',
            ],
            svg: SVG_DISQUES,
        },
    ],
};

// Le relier axes : le geste de lecture verticale (le SVG de l'exercice
// montre déjà les deux axes, la fiche reste sobre). Exemple HORS pool :
// cinquièmes/dixièmes — l'axe du haut ne tire que b ∈ {3, 4}.
const FICHE_AXES = {
    pages: [
        {
            titre: 'Le même point, deux graduations',
            lignes: [
                'Lis le point sur l\'axe du **haut** en comptant les graduations depuis 0 : par exemple 2 graduations sur un axe en cinquièmes, c\'est $\\dfrac{2}{5}$.',
                'Descends **tout droit** : la même position sur l\'axe du bas, gradué en dixièmes, se lit $\\dfrac{4}{10}$. Même point, donc $\\dfrac{2}{5} = \\dfrac{4}{10}$.',
                'Vérifie avec la propriété : **le même coefficient** en haut et en bas (ici $\\times 2$).',
            ],
        },
    ],
};

// Juger/reconnaître/classer : le test d'égalité par le coefficient, avec le
// contre-exemple additif (le piège n° 1 des V/F). Exemple HORS pools :
// 9/11 absent de POOL_A (les onzièmes s'arrêtent à 7/11) — distinct du
// 8/11 de FICHE_REGLE.
const FICHE_JUGER = {
    pages: [
        {
            titre: 'Égales ou pas ? Cherche le coefficient',
            lignes: [
                'Deux fractions sont égales si on passe de l\'une à l\'autre en **multipliant** le numérateur **et** le dénominateur par le **même nombre**.',
                'Ça marche : $\\dfrac{9}{11} = \\dfrac{9 \\times 2}{11 \\times 2} = \\dfrac{18}{22}$.',
                '**Additionner ne marche pas !** $\\dfrac{9}{11}$ et $\\dfrac{10}{12}$ ne sont **pas** égales : on a ajouté 1, pas multiplié. Prends ton brouillon et teste le coefficient à chaque fois.',
            ],
        },
    ],
};

const CP_627 = {
    egalite_decomposition_texte_trou_saisie: FICHE_REGLE,
    egalite_decomposition_texte: FICHE_REGLE,
    egalite_decomposition_qcm_unique: FICHE_REGLE,
    egalite_trou_direct_qcm_unique: FICHE_REGLE,
    egalite_trou_direct_texte: FICHE_REGLE,
    egalite_trou_entier_qcm_unique: FICHE_ENTIER,
    egalite_trou_entier_texte: FICHE_ENTIER,
    egalite_relier_disques_relier: FICHE_DISQUES,
    egalite_axes_gradues_relier: FICHE_AXES,
    egalite_vrai_faux_tableau_vf: FICHE_JUGER,
    egalite_reconnaitre_liste_qcm_multiple: FICHE_JUGER,
    egalite_classer_valeur_classer: FICHE_JUGER,
};

export default CP_627;
